import { ProjectType } from '../features/projects/ProjectsTable.types';
import { getUrlWithId, useGetFetch } from '../utils/reactQuery';
import { pathToUrl } from '../utils/router';
import { ApiRoutesEnum } from '../utils/routes';

export const useGetProject = (id: string) => {
  return useGetFetch<ProjectType>({
    url: pathToUrl(getUrlWithId(ApiRoutesEnum.getProject, id)),
    config: { enabled: !!id },
  });
};
